interface GiftCardStepperProps {
  currentStep: number;
}

const steps = ['Choose Amount', "Who's It For?", 'How to Send?', 'Your Details'];

export function GiftCardStepper({ currentStep }: GiftCardStepperProps) {
  return (
    <div className="w-full max-w-[600px] mx-auto mb-10 px-2">
      <div className="flex items-start">
        {steps.map((label, i) => {
          const active = i <= currentStep;
          return (
            <div key={label} className="flex items-start flex-1 last:flex-none min-w-0">
              <div className="flex flex-col items-center min-w-0">
                <div
                  className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${
                    active ? 'bg-[#8e2a2f]' : 'border-2 border-[#dde7e4]'
                  }`}
                >
                  <div
                    className={`rounded-full w-[7px] h-[7px] ${
                      active ? 'bg-white' : 'bg-[#c6d8d3]'
                    }`}
                  />
                </div>
                <p
                  className={`mt-2 font-['DM_Sans',sans-serif] font-bold text-[10px] sm:text-[12px] md:text-[14px] tracking-[-0.1px] text-center px-1 ${
                    i === currentStep ? 'text-[#3a3335]' : 'text-[#908e8e]'
                  }`}
                >
                  {label}
                </p>
              </div>
              {i < steps.length - 1 && (
                <div className="flex-1 h-[2px] bg-[#c6d8d3]/50 mt-[11px] mx-1 sm:mx-2 min-w-[12px]" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
